<style>
#modelingParametersModal .v--modal-box.v--modal {
  min-height: 270px !important;
  min-width: 450px !important;
}
#modelingParametersModal .v-text-field__suffix {
  color: grey;
  font-size: 16px;
  padding-right: 3px;
}
#modelingParametersModal input {
  text-align: right;
  padding-bottom: 3px;
  width: 50px;
}
#modelingParametersModal .v-input--selection-controls {
  justify-content: flex-end;
}
#modelingParametersModal .v-input--selection-controls__input {
  margin-right: 0px;
}
#modelingParametersModal .v-text-field__slot input,
#modelingParametersModal .v-select__selections input,
textarea {
  font-size: 12px;
}
</style>

<template>
  <Modal
    modalName="modelingParametersModal"
    title="Parametry modelowania"
    @saved="save"
    @opened="loadData"
    :buttons="['save']"
  >
    <v-layout>
      <v-list
        subheader
        style="width: 100%"
      >
        <v-subheader class="font--primary">Określenie parametrów modelowania</v-subheader>
        <v-list-tile class="list--el">
          <v-list-tile-content @click="parameters.static = !parameters.static">
            <v-list-tile-title>Czas symulacji [h]</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-text-field
              autofocus
              v-model="parameters.time"
            ></v-text-field>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile class="list--el">
          <v-list-tile-content @click="parameters.projectedReceivers = !parameters.projectedReceivers">
            <v-list-tile-title>Uwzględnij projektowanych odbiorców</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-checkbox
              @change="changeReceiversVisibility"
              v-model="parameters.projectedNetwork"
            ></v-checkbox>
          </v-list-tile-action>
        </v-list-tile>
        <v-layout
          row
          wrap
          style="padding-left: 16px; padding-right: 16px;"
        >
          <v-flex xs5>
            <v-select
              v-model="selectedStatuses"
              :items="modellingStatuses"
              label="Status"
              color="#4f7052"
              chips
              multiple
            ></v-select>
          </v-flex>
          <v-spacer />
          <v-flex xs5>
            <v-select
              v-model="selectedNetKinds"
              :items="modellingNetKinds"
              color="#4f7052"
              label="Rodzaj sieci"
              chips
              multiple
            ></v-select>
          </v-flex>
        </v-layout>
      </v-list>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    modellingStatuses: [],
    modellingNetKinds: [],
    selectedNetKinds: [],
    selectedStatuses: [],
    parameters: {
      time: 24,
      projectedNetwork: false
    }
  }),
  computed: {
    includeReceivers() {
      return this.$store.getters.getIncludedReceiver;
    },
    map() {
      return this.$store.getters.getMap;
    }
  },
  methods: {
    changeReceiversVisibility(e) {
      this.getLayerByName('virtualRecipientsLayer')
      this.$store.commit("setIncludeReceivers", e);
      this.parameters.projectedNetwork = e;
    },
    getLayerByName(name) {
      return this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == name;
        });
    },
    loadData() {
      if(this.getLayerByName('virtualRecipientsLayer')) {
        this.$store.commit("setIncludeReceivers", true);
        this.parameters.projectedNetwork = true;
      } else {
        this.$store.commit("setIncludeReceivers", false);
        this.parameters.projectedNetwork = false;
      }
      this.$store.dispatch('getSingleDict', 26).then(r => {
        this.modellingNetKinds = r.values;
      });
      this.$store.dispatch('getSingleDict', 30).then(r => {
        this.modellingStatuses = r.values;
      });

      this.$store.dispatch('getSingleSettings', 'EPANET_FILTER').then(r => {
        if(!r) {
          this.selectedStatuses = this.modellingStatuses.filter(el => el == 'Istniejący czynny' || el == "Nieudokumentowane");
          this.selectedNetKinds = [this.modellingNetKinds.find(el => el == 'Sieć wodociągowa ogólna')];
        } else {
          r = JSON.parse(r.replace(/\'/g, '\"'));
          this.selectedStatuses = r.statuses;
          this.selectedNetKinds = r.netKinds;
        }
      });
    },
    save() {
      const payload = {
        options: [
          {
            name: "_with_virtual_recipients",
            value: this.parameters.projectedNetwork ? "1" : "0"
          }
        ]
      }
      this.$store.dispatch('changeModellingOptions', payload).then(r => {
        if(!r) {
          this.$root.$emit("showSnackbar", "error", `${r}`);
          return;
        }
      });
      const settingsPayload = {
        EPANET_FILTER: {
          "statuses": this.selectedStatuses,
          "netKinds": this.selectedNetKinds
        }
      }
      this.$store.dispatch('changeSettings', settingsPayload).then(r => {
        if(!r) {
          this.$root.$emit("showSnackbar", "error", `${r}`);
          return;
        }
        this.$store.dispatch('getSettings')

      })
      this.$root.$emit("showSnackbar", "#304058", "Zapisano parametry modelowania");
      this.$modal.hide("modelingParametersModal");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/ModelingParameters.vue